<script setup>
const ServicesContent = defineAsyncComponent(() => import('~/components/molecules/ServicesContent.vue'));

</script>

<template>
  <ServicesContent />
</template>
